import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSnackbarStore = defineStore('snackbar', () => {
  // State
  const visible = ref(false)
  const currentSnackbar = ref(null)

  // Actions
  const show = (options) => {
    currentSnackbar.value = {
      message: '',
      type: 'info',
      timeout: 5000,
      location: 'bottom',
      multiLine: false,
      persistent: false,
      ...options
    }
    visible.value = true
  }

  const hide = () => {
    visible.value = false
    setTimeout(() => {
      currentSnackbar.value = null
    }, 300) // Wait for transition
  }

  const success = (message, options = {}) => {
    show({
      message,
      type: 'success',
      ...options
    })
  }

  const error = (message, options = {}) => {
    show({
      message,
      type: 'error',
      timeout: 8000, // Error messages stay longer
      ...options
    })
  }

  const warning = (message, options = {}) => {
    show({
      message,
      type: 'warning',
      timeout: 6000,
      ...options
    })
  }

  const info = (message, options = {}) => {
    show({
      message,
      type: 'info',
      ...options
    })
  }

  return {
    // State
    visible,
    currentSnackbar,
    
    // Actions
    show,
    hide,
    success,
    error,
    warning,
    info
  }
})